
import { mapState, mapMutations, mapActions } from 'vuex'
import SlideUpDown from 'vue-slide-up-down'
import Nav from './Nav'
import NewsTicker from './NewsTicker'
import Notice from './Notice'
import HeaderSearch from './HeaderSearch'
import MobileFooter from '~/components/Common/Layout/Footer/MobileFooter.vue'
import Menu from '~/constants/Menu'

export default {
  components: { Nav, NewsTicker, SlideUpDown, MobileFooter, Notice, HeaderSearch },
  data() {
    return { curMenuIdx: -1, slideDuration: 300, Menu, windowHeight: 0, tickerNews: [] }
  },

  computed: {
    ...mapState('ui', ['mobileMenuShow', 'isVisible']),
    ...mapState('member', ['memberInfo']),

    formattedUpdatedTime() {
      if (!this.tickerNews.length) return ''
      const item = this.tickerNews[0]
      const sendDate = item.sendDate
      const sendTime = item.sendTime
      if (!sendDate || !sendTime) return ''
      const y = sendDate.slice(0, 4)
      const m = sendDate.slice(4, 6)
      const d = sendDate.slice(6, 8)
      const hh = sendTime.slice(0, 2)
      const mm = sendTime.slice(2, 4)
      const ss = sendTime.slice(4, 6)
      const fullDate = new Date(`${y}-${m}-${d}T${hh}:${mm}:${ss}`)
      const weekdays = ['일', '월', '화', '수', '목', '금', '토']
      const weekday = weekdays[fullDate.getDay()]
      return `${y}년 ${m}월 ${d}일 (${weekday})`
    },
  },

  watch: {
    $route() {
      this.SET_MOBILE_MENU_SHOW(false)
    },
    windowHeight(curr, prev) {
      const ref = this.$refs.mobileHeader
      if (!ref) return
      if (typeof window === 'undefined') return
      const isMobileLike = window.innerWidth < 1280
      if (!isMobileLike) {
        ref.style.top = '0px'
        return
      }
      if (curr < 50) {
        ref.style.top = '0px'
        return
      }
      ref.style.top = prev > curr ? '0px' : '-50px'
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapMutations('ui', ['SET_MOBILE_MENU_SHOW']),
    ...mapActions('modal', ['SHOW_ALERT', 'SHOW_FIND_ID', 'SHOW_LOGIN']),
    ...mapActions('main', ['GET_RELOAD_MAIN']),

    onNewsReceived(news) {
      this.tickerNews = news
    },

    onClickMobileMenu(idx) {
      this.curMenuIdx = idx === this.curMenuIdx ? -1 : idx
    },

    onClickMobileMenuOpen() {
      this.SET_MOBILE_MENU_SHOW(true)
    },

    onClickMobileMenuClose() {
      this.SET_MOBILE_MENU_SHOW(false)
    },

    onClickLogout() {
      this.$method.logout()
      this.SET_MOBILE_MENU_SHOW(false)
    },

    onClickLogo() {
      this.GET_RELOAD_MAIN()
      if (this.$route.path === '/') this.$router.go()
      else this.$router.push('/')
    },

    handleScroll() {
      this.windowHeight = window.pageYOffset
    },

    handleResize() {
      const ref = this.$refs.mobileHeader
      if (!ref) return
      if (window.innerWidth >= 1280) ref.style.top = '0px'
    },
  },
}
